import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  Timestamp,
  limit,
} from "firebase/firestore";
import { db } from "../../../firebase-config";
import ReactApexChart from "react-apexcharts";
import Card from "@mui/material/Card";

export default function RatesChart({ yearValue }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = React.useState(true);

  const firstDate = new Date();
  const lastDate = new Date();
  let firstTimestamp = React.useRef();
  let lastTimestamp = React.useRef();

  if (typeof yearValue === "number") {
    lastDate.setFullYear(lastDate.getFullYear() - yearValue);
    const firstYear = firstDate.getFullYear();
    const firstDay = firstDate.getDate();
    const firstMonth = firstDate.getMonth() + 1;

    const lastMonth = lastDate.getMonth() + 1;
    const lastYear = lastDate.getFullYear();
    const lastDay = lastDate.getDate();
    firstTimestamp = Timestamp.fromDate(
      new Date(`${firstYear}-${firstMonth}-${firstDay}`)
    );
    lastTimestamp = Timestamp.fromDate(
      new Date(`${lastYear}-${lastMonth}-${lastDay}`)
    );
  } else if (yearValue === "all") {
    lastDate.setFullYear(2000);
    const firstYear = firstDate.getFullYear();
    const firstDay = firstDate.getDay();
    const firstMonth = firstDate.getMonth();

    const lastMonth = lastDate.getMonth();
    const lastYear = lastDate.getFullYear();
    const lastDay = lastDate.getDay();

    const newFirstDate = Date.parse(firstMonth + firstDay + firstYear);
    const newLastDate = Date.parse(lastMonth + lastDay + lastYear);
    firstTimestamp = Timestamp.fromDate(new Date(newFirstDate));
    lastTimestamp = Timestamp.fromDate(new Date(newLastDate));
  }

  useEffect(() => {
    setLoading(true);

    async function getDocuments({ firstTimestamp, lastTimestamp }) {
      const q = query(
        collection(db, "interbank-test"),
        where("date", "<=", firstTimestamp),
        where("date", ">=", lastTimestamp),
        orderBy("date")
        // limit(370)
      );
      const allDocs = [];
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        allDocs.push(doc.data());
      });

      const allDateRates = [];

      allDocs.forEach((e) => {
        const _date = e["date"];
        const Rate = e["rate"];
        const date = _date.toDate().getTime();
        const dateRate = [date, Rate];
        allDateRates.push(dateRate);
      });
      setData(allDateRates);
      setLoading(false);
    }
    getDocuments({
      firstTimestamp: firstTimestamp,
      lastTimestamp: lastTimestamp,
    });
  }, []);

  const options = {
    theme: {
      mode: "dark",
    },
    chart: {
      id: "area-datetime",
      type: "area",
      height: 400,
      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true,
      },
      foreColor: "#ccc",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false | '<img src="/static/icons/reset.png" width="20">',
          customIcons: [],
        },
      },
    },
    colors: ["#00BAEC"],
    stroke: {
      width: 3,
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      style: "hollow",
      size: 0,
      colors: ["#000524"],
      strokeColor: "#00BAEC",
      strokeWidth: 3,
    },
    xaxis: {
      type: "datetime",
    },
    tooltip: {
      x: {
        format: "dd MMM yyyy",
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        gradientToColors: ["rgba(27,27,251,1)"],
        shadeIntensity: 1,
        type: "vertical",
        inverseColors: false,
        opacityFrom: 0.55,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
    grid: {
      borderColor: "#555",
      clipMarkers: false,
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    title: {
      text: "InterBank Lending Rate",
      align: "center",
    },
  };

  return loading ? (
    <h1>Loading</h1>
  ) : (
    <>
      {data.length > 0 ? (
        <Card>
          <ReactApexChart
            options={options}
            series={[
              {
                name: "Interbank Rate",
                data: data,
              },
            ]}
            height={400}
            type="area"
          />
        </Card>
      ) : (
        <h1>No Data Available</h1>
      )}
    </>
  );
}
